'use client'

import { ReactNode } from 'react'

import SsrContextProvider from '@/contexts/providers/SsrContextProvider'
import { useSsrContext } from '@/contexts/ssr'

export default function CurrencyContextProvider({
  children,
  currency,
}: {
  children: ReactNode
  currency: string
}) {
  const { requestUserAgent, countryCode, regionCode } = useSsrContext()

  return (
    <SsrContextProvider
      selectedCurrency={currency}
      requestUserAgent={requestUserAgent}
      countryCode={countryCode}
      regionCode={regionCode}
    >
      {children}
    </SsrContextProvider>
  )
}
